import httpClient from "../httpClient";
import { API_ENDPOINTS } from "../apiEndpoints";
import { API_BASE_URL } from "../apiConfig";
import axios from "axios";

export const itemService = {
  getItems: async () => {
    const response = await httpClient.get(
      API_ENDPOINTS.GET_IV_ItemAttributesBasedMenu,
    );
    return response.data;
  },
  getItemsWithTagList: async (tagName) => {
    const response = await httpClient.get(
      `${API_ENDPOINTS.GET_ItemsWithTagList}?tagName=${tagName}`,
    );
    return response.data;
  },
  getItemSearchWithAttributes: async (
    key,
    value,
    pageNumber = 1,
    pageSize = 10,
  ) => {
    const response = await httpClient.get(
      `${API_ENDPOINTS.GET_ItemSearchWithAttributes}?key=${encodeURIComponent(key)}&Value=${encodeURIComponent(value)}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    );
    return response.data;
  },
  getItemDetailAndRelatedItems: async (
    itemId,
    pageNumber = 1,
    pageSize = 10,
  ) => {
    const response = await httpClient.get(
      `${API_ENDPOINTS.GET_ItemDetailAndRelatedItems}?ItemID=${itemId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    );
    return response.data;
  },
  getItemAndModelWithSearch: async (keyword) => {
    const response = await httpClient.get(
      `${API_ENDPOINTS.GET_ItemAndModelWithSearch}?keyword=${encodeURIComponent(keyword)}`,
    );
    return response.data;
  },
  accountLogin: async (userName, password) => {
    // Use erp.gold token for login API
    const response = await axios.post(
      `${API_BASE_URL}/${API_ENDPOINTS.POST_AccountLogin}`,
      {
        UserName: userName,
        Password: password,
      },
      {
        headers: {
          Token: "erp.gold",
          UserName:
            process.env.REACT_APP_API_USERNAME || "production@wireox.com",
          Cookie:
            process.env.REACT_APP_API_COOKIE ||
            "ASP.NET_SessionId=1xsvbpyq1wg4ymh3ihdtz243",
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  },
  accountCreation: async (accountData) => {
    // Use erp.gold token for create account API
    const response = await axios.post(
      `${API_BASE_URL}/${API_ENDPOINTS.POST_AccountCreation}`,
      accountData,
      {
        headers: {
          Token: "erp.gold",
          UserName:
            process.env.REACT_APP_API_USERNAME || "production@wireox.com",
          Cookie:
            process.env.REACT_APP_API_COOKIE ||
            "ASP.NET_SessionId=1xsvbpyq1wg4ymh3ihdtz243",
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  },
  verifyOTP: async (email, otpCode) => {
    // Verify OTP code
    const response = await axios.post(
      `${API_BASE_URL}/${API_ENDPOINTS.POST_VerifyOTP}`,
      {
        Email: email,
        OTPCode: otpCode,
      },
      {
        headers: {
          Token: "erp.gold",
          UserName:
            process.env.REACT_APP_API_USERNAME || "production@wireox.com",
          Cookie:
            process.env.REACT_APP_API_COOKIE ||
            "ASP.NET_SessionId=1xsvbpyq1wg4ymh3ihdtz243",
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  },
  resendOTP: async (email) => {
    // Resend OTP code
    const response = await axios.post(
      `${API_BASE_URL}/${API_ENDPOINTS.POST_ResendOTP}`,
      {
        Email: email,
      },
      {
        headers: {
          Token: "erp.gold",
          UserName:
            process.env.REACT_APP_API_USERNAME || "production@wireox.com",
          Cookie:
            process.env.REACT_APP_API_COOKIE ||
            "ASP.NET_SessionId=1xsvbpyq1wg4ymh3ihdtz243",
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  },
};
